/*
 * Frame product pages: click a gallery image (desktop) to open it full screen.
 * Click the image again to zoom to 2x and follow the mouse; Esc, the close
 * button or a click on the backdrop closes it. Arrow keys move between images.
 * Uses a native <dialog>, so focus and Escape are handled by the browser.
 */
(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (pointer: fine)');
  const gallery = document.querySelector('.gp-frame-product-section .product-gallery__main');
  if (!gallery || !('HTMLDialogElement' in window)) return;

  const fullSize = (img) => {
    const src = img.currentSrc || img.src || '';
    try {
      const url = new URL(src, location.href);
      url.searchParams.set('width', '2400');
      return url.toString();
    } catch (e) {
      return src;
    }
  };
  // Gallery slides, in order (Flickity may add clones; skip those).
  const images = () => [...gallery.querySelectorAll('.product-gallery__image img, .image__container img')]
    .filter((img, i, all) => all.indexOf(img) === i && !img.closest('.is-clone'));

  const dialog = document.createElement('dialog');
  dialog.className = 'gp-zoom';
  dialog.setAttribute('aria-label', 'Product image');
  dialog.innerHTML = `
    <button type="button" class="gp-zoom__close" aria-label="Close">
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="m5 5 10 10M15 5 5 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
    </button>
    <button type="button" class="gp-zoom__nav gp-zoom__nav--prev" aria-label="Previous image">
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <figure class="gp-zoom__stage"><img class="gp-zoom__img" alt=""></figure>
    <button type="button" class="gp-zoom__nav gp-zoom__nav--next" aria-label="Next image">
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <p class="gp-zoom__hint">Click to zoom</p>`;
  document.body.appendChild(dialog);

  const stage = dialog.querySelector('.gp-zoom__stage');
  const big = dialog.querySelector('.gp-zoom__img');
  const hint = dialog.querySelector('.gp-zoom__hint');
  let index = 0;

  function show(i) {
    const list = images();
    if (!list.length) return;
    index = (i + list.length) % list.length;
    const img = list[index];
    big.classList.remove('is-zoomed');
    big.style.transformOrigin = '';
    big.src = fullSize(img);
    big.alt = img.alt || '';
    const many = list.length > 1;
    dialog.querySelectorAll('.gp-zoom__nav').forEach((b) => { b.hidden = !many; });
    hint.textContent = 'Click to zoom';
  }

  function open(img) {
    show(images().indexOf(img));
    dialog.showModal();
    document.documentElement.classList.add('gp-zoom-open');
  }

  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('gp-zoom-open');
    big.classList.remove('is-zoomed');
  });

  // Zoom toward the point clicked, then follow the mouse while zoomed.
  const aim = (event) => {
    const r = big.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((event.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - r.top) / r.height) * 100));
    big.style.transformOrigin = `${x}% ${y}%`;
  };
  big.addEventListener('click', (event) => {
    event.stopPropagation();
    if (!big.classList.contains('is-zoomed')) aim(event);
    big.classList.toggle('is-zoomed');
    hint.textContent = big.classList.contains('is-zoomed') ? 'Click to zoom out' : 'Click to zoom';
  });
  big.addEventListener('mousemove', (event) => { if (big.classList.contains('is-zoomed')) aim(event); });

  dialog.querySelector('.gp-zoom__close').addEventListener('click', () => dialog.close());
  dialog.querySelector('.gp-zoom__nav--prev').addEventListener('click', (e) => { e.stopPropagation(); show(index - 1); });
  dialog.querySelector('.gp-zoom__nav--next').addEventListener('click', (e) => { e.stopPropagation(); show(index + 1); });
  // A click on the dark backdrop (outside the picture and buttons) closes.
  dialog.addEventListener('click', (event) => { if (event.target === dialog || event.target === stage) dialog.close(); });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
  });

  // Desktop only: on touch screens the gallery swipes, and pinch-zoom already works.
  // A mouse drag (sliding the gallery) isn't treated as a click.
  let down = null;
  gallery.addEventListener('pointerdown', (event) => { down = { x: event.clientX, y: event.clientY }; }, true);
  gallery.addEventListener('click', (event) => {
    if (!desktop.matches) return;
    if (down && Math.hypot(event.clientX - down.x, event.clientY - down.y) > 6) return;
    const img = event.target.closest('img');
    if (!img || !gallery.contains(img)) return;
    event.preventDefault();
    event.stopPropagation();
    open(img);
  }, true);
  const markZoomable = () => gallery.classList.toggle('gp-zoomable', desktop.matches);
  markZoomable();
  if (desktop.addEventListener) desktop.addEventListener('change', markZoomable);
})();
